import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ResponsiveImage from 'components/images/responsive-image'
import env from 'config/env'

const CarouselThumbnail = ({
  img,
  idx,
  currentIdx,
  maxThumbnails,
  skipThumbnails,
  setSkipThumbnails,
}) => {
  const imgPath = img.path || img.full_cover_image_path

  const onClickThumbnail = () => {
    const heroImg = document.getElementById(`hero-img-${idx}`)
    heroImg.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    })
  }

  useEffect(() => {
    const positionCurrent = currentIdx - skipThumbnails
    // change thumbnail images list when scroll up
    if (skipThumbnails !== 0 && currentIdx < skipThumbnails) {
      setSkipThumbnails(skipThumbnails - 1)
    }

    // change thumbnail images list when scroll down
    if (positionCurrent + 1 > maxThumbnails) {
      setSkipThumbnails(skipThumbnails + 1)
    }

    // change thumbnail images list when scroll up and current index less than 4
    if (positionCurrent + 1 < maxThumbnails) {
      if (currentIdx < 4) {
        setSkipThumbnails(0)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIdx])

  // hide some thumbnail images if it's > maxThumbnails
  if (skipThumbnails > idx || idx - skipThumbnails >= maxThumbnails) {
    return null
  }

  return (
    <div
      className={`pdp__carousel-thumbnail${
        currentIdx === idx ? ' pdp__current-thumbnail' : ''
      }`}
      style={{ position: 'relative' }}
      onClick={() => onClickThumbnail()}
      onKeyDown={() => onClickThumbnail()}
      role="button"
      tabIndex="0"
    >
      <ResponsiveImage
        src={img.full_path || `${env.IMG_HOST}${imgPath}`}
        alt="thumbnail item"
        imgRatio={1.33}
      />
    </div>
  )
}

CarouselThumbnail.propTypes = {
  img: PropTypes.shape({
    image_type: PropTypes.string,
    path: PropTypes.string,
    full_cover_image_path: PropTypes.string,
    full_path: PropTypes.string,
  }).isRequired,
  idx: PropTypes.number.isRequired,
  currentIdx: PropTypes.number.isRequired,
  maxThumbnails: PropTypes.number.isRequired,
  skipThumbnails: PropTypes.number.isRequired,
  setSkipThumbnails: PropTypes.func.isRequired,
}

export default CarouselThumbnail
